<template>
    <v-layout>
        <div class="col-12">
            <v-toolbar flat>
                <v-toolbar-title>{{ $t('transfer_coins_to_redeem_partner') }}</v-toolbar-title>
                <template v-slot:extension>
                    <v-tabs
                            v-model="tab"
                            align-with-title
                    >
                        <v-tabs-slider color="primary"></v-tabs-slider>
                        <v-tab>{{ $t('transfer_coins') }}</v-tab>
                        <v-tab>{{ $t('transfer_queue') }}</v-tab>
                        <v-tab>{{ $t('redeems_log') }}</v-tab>
                    </v-tabs>
                </template>
            </v-toolbar>
            <v-tabs-items v-model="tab">
                <v-tab-item>
                    <v-card>
                        <redeems v-if="tab==0"/>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card>
                        <redeemsqueue v-if="tab==1" mode="queue"/>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card>
                        <redeemsqueue v-if="tab==2" mode="log"/>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </v-layout>
</template>
<script>
    import Redeems from "@/views/Redeems";
    import RedeemsQueue from "@/views/RedeemsQueue";
    export default {
        components: {
            redeems: Redeems,
            redeemsqueue: RedeemsQueue,
        },
        name: "SARedeemsWrapper",
        data: () => ({
            loading: false,
            tab: null,
        })
    }
</script>
